<div class="login d-flex flex-row align-items-center justify-content-center">
    <div class="login__main-content">
        <div class="info info__wrapper">
            <h1 class="info__heading-text">{{ 'LOGIN.INTRO' | translate }}</h1>
            <p class="info__text">{{ 'LOGIN.INFO' | translate }}</p>
            <p class="info__text">{{ 'LOGIN.INFO_ADDITIONAL' | translate }}</p>
            <p class="info__text">{{ 'LOGIN.INFO_ADDITIONAL1' | translate }}</p>
            <ul>
                <li>{{ 'LOGIN.INFO_PRICING_1' | translate }}</li>
                <li>{{ 'LOGIN.INFO_PRICING_2' | translate }}</li>
                <li>{{ 'LOGIN.INFO_PRICING_3' | translate }}</li>
                <li>{{ 'LOGIN.INFO_PRICING_4' | translate }}</li>
            </ul>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()" id="login-form" novalidate>
            <div class="login__wrapper">
                <div class="row">
                    <div class="col-6">
                        <h5 class="login__heading-text">{{ 'INFO.SIGN_IN' | translate }}</h5>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <label style="width: 55%;" class="remember-label">
                            {{ 'LOGIN.REMEMBER_ME' | translate }}
                            <input type="checkbox" id="rememberme" formControlName="rememberme" name="rememberme"
                                (change)="onChangeRememberMe(rememberme?.value)">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-row label-info">
                            <label for="username">{{ 'LOGIN.EMAIL' | translate }}</label>
                            <div *ngIf="username?.invalid && (username?.dirty || username?.touched)" class="alert">
                                <div *ngIf="username?.errors?.['required']">
                                    <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                                        pTooltip="{{ 'INFO.EMAIL_REQUIRED' | translate }}" tooltipPosition="top"></i>
                                </div>
                                <div *ngIf="username?.errors?.['pattern']">
                                    <i class="pi pi-info-circle me-1 pt-2 error-icon"
                                        pTooltip="{{ 'INFO.INVALID_EMAIL' | translate }}" tooltipPosition="top"></i>
                                </div>
                            </div>
                        </div>
                        <input type="email" id="username" formControlName="username" name="username"
                            placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" required email>
                    </div>
                    <div class="col-12">
                        <div class="d-flex flex-row label-info">
                            <label for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
                            <div *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="alert">
                                <div *ngIf="password?.errors?.['required']">
                                    <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                                        pTooltip="{{ 'INFO.PASSWORD_REQUIRED' | translate }}" tooltipPosition="top"></i>
                                </div>
                                <div *ngIf="password?.errors?.['minlength'] || password?.errors?.['pattern']">
                                    <i class="pi pi-info-circle me-1 pt-2 error-icon"
                                        pTooltip="{{ 'INFO.PASSWORD_PATTERN' | translate }}" tooltipPosition="top"></i>
                                </div>
                            </div>
                        </div>
                        <input type="password" id="password" formControlName="password" name="password"
                            placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" required autocomplete>
                        <a class="login__link login__wspace" routerLink="/forgot-password">{{ 'INFO.NOTE_006' |
                            translate }}</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p class="login__text">{{ 'INFO.NOTE_004' | translate }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button (click)="signInWithFacebook()"
                            class="btn-social-login d-flex justify-content-center align-items-center" type="button"><i
                                class="pi pi-facebook me-2"></i>{{ 'INFO.SIGN_FB' | translate }}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">

                        <button type="submit" [disabled]="!(loginForm.valid || rememberme?.value)"
                            class="signin-button button full">{{ 'INFO.SIGN_IN' | translate }}</button>
                        <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <p class="login__text">{{ 'INFO.NOTE_005' | translate }}</p>
                        <button type="button" routerLink="/sign-up" class="signup-button button simple">{{
                            'INFO.SIGN_UP' | translate }}</button>
                    </div>
                </div> -->
            </div>
        </form>
    </div>
</div>